module.exports = __webpack_public_path__ + "static/media/Eco_drive.a8ade8bf.png";